export default "__VITE_ASSET__Ct9zBlS1__"